export default {"src":"/_next/static/media/pin-green-desktop.9648b181.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};